var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1475 5.8275C13.095 5.82 13.0425 5.82 12.99 5.8275C11.8275 5.79 10.905 4.8375 10.905 3.6675C10.905 2.475 11.8725 1.5 13.0725 1.5C14.265 1.5 15.24 2.4675 15.24 3.6675C15.2325 4.8375 14.31 5.79 13.1475 5.8275Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5925 11.0233C14.7525 11.5858 13.575 11.7958 12.4875 11.6533C12.7725 11.0383 12.9225 10.3558 12.93 9.63585C12.93 8.88585 12.765 8.17335 12.45 7.55085C13.56 7.40085 14.7375 7.61085 15.585 8.17335C16.77 8.95335 16.77 10.2358 15.5925 11.0233Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.83 5.8275C4.8825 5.82 4.935 5.82 4.9875 5.8275C6.15 5.79 7.0725 4.8375 7.0725 3.6675C7.0725 2.4675 6.105 1.5 4.905 1.5C3.7125 1.5 2.745 2.4675 2.745 3.6675C2.745 4.8375 3.6675 5.79 4.83 5.8275Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.9125 9.63599C4.9125 10.3635 5.07 11.0535 5.355 11.676C4.2975 11.7885 3.195 11.5635 2.385 11.031C1.2 10.2435 1.2 8.96099 2.385 8.17349C3.1875 7.63349 4.32 7.41599 5.385 7.53599C5.0775 8.16599 4.9125 8.87849 4.9125 9.63599Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.09 11.9025C9.03 11.895 8.9625 11.895 8.895 11.9025C7.515 11.8575 6.4125 10.725 6.4125 9.33C6.42 7.905 7.5675 6.75 9 6.75C10.425 6.75 11.58 7.905 11.58 9.33C11.5725 10.725 10.4775 11.8575 9.09 11.9025Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.6525 13.4555C5.52 14.213 5.52 15.458 6.6525 16.208C7.9425 17.0705 10.0575 17.0705 11.3475 16.208C12.48 15.4505 12.48 14.2055 11.3475 13.4555C10.065 12.593 7.95 12.593 6.6525 13.4555Z",
    fill: "#57A6BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.259e74ac2ab4b5a2c56b6842fbc41c84.svg";
export { ForwardRef as ReactComponent };